import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Constants } from '../../shared/models/constants';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {    

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                map((event: HttpEvent<any>) => {
                    return event;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
      console.error('server error:', error);
        if (error.status === 401) {
            //on unauthorized
            localStorage.removeItem(Constants.AUTH_TOKEN);
            localStorage.removeItem(Constants.USER_ROLE);
            localStorage.removeItem(Constants.USER_FULL_NAME);
            localStorage.removeItem(Constants.REFRESH_TOKEN);
            localStorage.removeItem(Constants.USER_ID);
            localStorage.removeItem(Constants.LANDING_URL);
            window.location.assign('/user/login');
        }
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error);
    }
}

